import { Theme } from '@mui/joy';
import { ColDef } from 'ag-grid-community';

import { ICliJob } from 'cli/types';
import { QuoteEntityType, QuoteListType } from 'quotes/enums';

import { allColumnDefs } from './allColumnDefs';
import { getOrderColumnDefs, getQuoteColumnDefs } from './columnDefs';

interface IOptions {
  pendingCoreCliJob?: ICliJob;
  quoteListType?: QuoteListType;
}

export const getColumnDef = (
  theme: Theme,
  entityType = QuoteEntityType.QUOTE,
  { pendingCoreCliJob, quoteListType = QuoteListType.GLOBAL }: IOptions = {}
): ColDef[] => {
  const allColumns = allColumnDefs(theme, entityType, { pendingCoreCliJob, quoteListType });

  switch (entityType) {
    case QuoteEntityType.ORDER:
      return getOrderColumnDefs(allColumns, quoteListType);
    case QuoteEntityType.QUOTE:
    default:
      return getQuoteColumnDefs(allColumns, quoteListType);
  }
};
